import { render, staticRenderFns } from "./imageinfodetail.vue?vue&type=template&id=71d2b539&scoped=true&"
import script from "./imageinfodetail.vue?vue&type=script&lang=js&"
export * from "./imageinfodetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d2b539",
  null
  
)

export default component.exports